import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import Page from 'components/Page';
import BannerImage from 'components/BannerImage';
import ColumnTwo from 'components/ColumnTwo';
import ContentBlock from 'components/ContentBlock';
import ScrollAnimation from 'components/ScrollAnimation';
import SectionAccordion from './elements/Accordion/Accordion';

class Interiors extends Component {
  state = {
    hasTourPlayed: false,
  };

  listener = null;

  handleTour = () => this.setState({ hasTourPlayed: true });

  componentDidMount() {
    this.listener = setInterval(() => {
      let el = document.activeElement;
      if (el && el.tagName == 'IFRAME') {
        this.handleTour();
        clearInterval(this.listener);
      }
    }, 100);
  }

  componentWillUnmount() {
    if (this.listener) {
      clearInterval(this.listener);
    }
  }

  render() {
    return (
      <Page
        background={require('src/assets/images/interiors/banner.jpg')}
        banner={<BannerImage />}
      >
        <ScrollAnimation>
          <ColumnTwo
            left={
              <ContentBlock
                title={t('interiors.title')}
                subtitle={t('interiors.subtitle')}
              >
                <p>{t('interiors.copy')}</p>
              </ContentBlock>
            }
            right={
              <FeaturedImage
                src={require('src/assets/images/interiors/ensuite.jpg')}
              />
            }
          />
        </ScrollAnimation>

        <ScrollAnimation>
          <FullImage
            style={{
              backgroundImage: `url(${require('src/assets/images/interiors/banner2.jpg')})`,
            }}
          >
            <span>{t('interiors.captions.0')}</span>
          </FullImage>
        </ScrollAnimation>

        <ScrollAnimation>
          <SectionAccordion />
        </ScrollAnimation>

        <ScrollAnimation>
          <Tour id="virtualtour">
            <Placeholder active={!this.state.hasTourPlayed}>
              <h3>
                take a virtual tour
                <br />
                of our display suite
              </h3>
              <img
                src={require('src/assets/images/icons/play.svg')}
                alt="Play"
              />
            </Placeholder>
            <iframe
              width="100%"
              height="100%"
              src="https://my.matterport.com/show/?m=EQ8XCLw9B9B&amp;brand=0"
              frameBorder="0"
              allowFullScreen
              allow="vr"
              title="Presentation Centre"
            />
          </Tour>
        </ScrollAnimation>
      </Page>
    );
  }
}

const FullImage = styled.div`
  height: 778px;
  position: relative;
  background-size: cover;
  background-position: center center;
  @media (max-width: ${media.md}) {
    height: 500px;
  }
  @media (max-width: ${media.sm}) {
    height: 430px;
  }
  span {
    position: absolute;
    left: 15px;
    bottom: 15px;
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.font};
  }
`;

const FeaturedImage = styled.img`
  float: right;
  max-width: 100%;
  @media (max-width: ${media.md}) {
    float: none;
    margin: 0 auto;
    display: block;
  }
`;

const Tour = styled.div`
  height: 778px;
  width: 100%;
  position: relative;
  @media (max-width: ${media.md}) {
    height: 500px;
  }
  @media (max-width: ${media.sm}) {
    height: 430px;
  }
`;

const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  opacity: ${props => (props.active ? 1 : 0)};
  pointer-events: none;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.3)
    ),
    url(${require('src/assets/images/interiors/banner3.jpg')});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  transition: 0.3s ease;
  img {
    margin-top: 30px;
  }
  h3 {
    ${({ theme }) => theme.fontHeader};
    font-size: 36px;
    line-height: 1.22;
    text-transform: uppercase;
    text-align: center;
    color: white;
  }
  @media (max-width: ${media.md}) {
    img {
      width: 160px;
    }
  }
  @media (max-width: ${media.sm}) {
    h3 {
      font-size: 24px;
    }
    img {
      width: 120px;
    }
  }
`;

export default Interiors;



// WEBPACK FOOTER //
// ./src/pages/Interiors/Interiors.js